export const columnsToHideForMobile = {
  actions: false,
  SUBJECT: false,
  COURSE_NUMBER: false,
};
